import Rest from '@services/Rest';

/**
 * @typedef {removeUserSettings}
 */
export default class removeUserSettings extends Rest {
  /**
   * @type {String}
   */
  static resource = '/admin/update-transaction-gateway'
}
